const ROUTER_NAME_PREFIX = 'wikiInSMyStuff-';
const MAIN_URL_PREFIX = '/wiki/';

export {ROUTER_NAME_PREFIX, MAIN_URL_PREFIX}